import * as tslib_1 from "tslib";
import "../../CommonImports";
import "../../Core/core.css";
import "./Tabs.css";
import * as React from "react";
import { FocusGroupContext } from '../../FocusGroup';
import { FocusZoneContext } from '../../FocusZone';
import { Icon } from '../../Icon';
import { Observer } from '../../Observer';
import { Pill } from '../../Pill';
import { Tooltip } from '../../TooltipEx';
import { css, getSafeId } from '../../Util';
import { getFriendlyDisplayValue } from '../../Utilities/FriendlyNumber';
/**
 * Presentational component that represents a single tab.
 */
var Tab = /** @class */ (function (_super) {
    tslib_1.__extends(Tab, _super);
    function Tab() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onClick = function (event) {
            var url = _this.props.url;
            var updatePivot = true;
            // If ctrl-click is pressed, and there is a URL specified for this item, then
            // don't handle the click here, allowing the browser to perform a navigation
            // (i.e. open in a new tab/window)
            if (event.ctrlKey) {
                if (url) {
                    updatePivot = false;
                }
            }
            if (updatePivot) {
                event.preventDefault();
                _this.updateSelectedItem(event);
            }
        };
        _this.onKeyDown = function (event) {
            if (!event.defaultPrevented) {
                if (event.which === 32 /* space */ || event.which === 13 /* enter */) {
                    event.preventDefault();
                    _this.updateSelectedItem(event);
                }
            }
        };
        return _this;
    }
    Tab.prototype.render = function () {
        var _this = this;
        var _a = this.props, ariaLabel = _a.ariaLabel, index = _a.index, setSize = _a.setSize, id = _a.id, isSelected = _a.isSelected, url = _a.url;
        var TagName = url ? "a" : "div";
        return (React.createElement(Observer, { badgeCount: this.props.badgeCount }, function (props) {
            var tabContent = _this.renderTabContent(props.badgeCount);
            return (React.createElement(FocusGroupContext.Consumer, null, function (focusGroupContext) { return (React.createElement(FocusZoneContext.Consumer, null, function (zoneContext) { return (React.createElement(TagName, { "aria-label": ariaLabel, "aria-posinset": index !== undefined ? index + 1 : undefined, "aria-selected": isSelected, "aria-setsize": setSize, className: css("bolt-tab focus-treatment flex-noshrink", isSelected ? "selected" : ""), "data-focuszone": zoneContext.focuszoneId, href: url, id: getSafeId("tab-" + id), key: id, onClick: _this.onClick, onKeyDown: _this.onKeyDown, role: "tab", tabIndex: focusGroupContext.focusedElementId === "tab-" + id ? 0 : -1 }, tabContent)); })); }));
        }));
    };
    Tab.prototype.renderTabContent = function (badgeCount) {
        var _a = this.props, name = _a.name, iconProps = _a.iconProps, ariaLabel = _a.ariaLabel;
        var badgeDisplayValue = badgeCount !== undefined ? getFriendlyDisplayValue(badgeCount) : undefined;
        var badgeTooltip = undefined;
        if (badgeCount && badgeDisplayValue !== badgeCount.toString()) {
            badgeTooltip = badgeCount.toString();
        }
        var badge = badgeDisplayValue && (React.createElement(Pill, { className: "bolt-tab-badge", containsCount: true, size: 0 /* compact */, contentClassName: "text-ellipsis", excludeTabStop: true }, badgeDisplayValue));
        if (badgeTooltip) {
            badge = React.createElement(Tooltip, { text: badgeTooltip }, badge);
        }
        var icon = iconProps !== undefined && Icon(tslib_1.__assign({ className: "bolt-tab-icon" }, iconProps));
        var text = name && (React.createElement(Tooltip, { text: name, overflowOnly: true },
            React.createElement("span", { className: "bolt-tab-text", "data-content": name }, name)));
        if (icon && !text && ariaLabel) {
            icon = React.createElement(Tooltip, { text: ariaLabel }, icon);
        }
        return (React.createElement("span", { className: "bolt-tab-inner-container" },
            icon,
            text,
            badge));
    };
    /**
     * Updates the state with the new selected pivot.
     */
    Tab.prototype.updateSelectedItem = function (ev) {
        var onClick = this.props.onClick;
        if (ev && this.props.onBeforeTabChange && !this.props.onBeforeTabChange(ev, this.props.id, this.props.url)) {
            ev.preventDefault();
            return;
        }
        // Update notifiers
        if (onClick) {
            onClick(this.props.id);
        }
    };
    return Tab;
}(React.Component));
export { Tab };
